<!-- 找回密码 -->
<template>
  <div>
    <div class="logintwo">
      <div class="login-titles">
        <span style="color: #212020">找回密码</span>
      </div>
      <el-form class="loginaccount" :model="rulesForm" :rules="rules" ref="rulesForm" v-if="twoShow">
        <el-form-item class="login-row" prop="receiveNo">
          <el-input v-model="rulesForm.receiveNo" placeholder="输入手机号" @blur="testItem" />
        </el-form-item>
        <!-- :disabled=" slideShow ? true: false" -->
        <el-form-item label="验证" prop="isLock" v-if="slideShow ? true : false">
          <!--  :disabled=" slideShow ? false: true" -->
          <sliderVerifyCode v-model="rulesForm.isLock" @change="handlerLock"></sliderVerifyCode>
        </el-form-item>

        <el-form-item class="login-row" prop="control">
          <el-input :type="showPwd ? 'text' : 'password'" style="width: 68%" v-model="rulesForm.control"
            placeholder="短信验证码" />
          <el-button type="button" size="small" class="btn btn-info" id="send" :disabled="btnShow ? false : true"
            @click="getCode(rulesForm)">
            <span v-show="count_show">发送验证码</span>
            <span v-show="!count_show" class="count">{{ count }} </span>
          </el-button>
        </el-form-item>

        <div class="login-btn">
          <!-- <div v-if="name && pwd" class="login-bttn" @click="login">立即登录</div>
      <div v-else class="login-bttn disabled">立即登录</div> -->
          <el-button :disabled="rulesForm.receiveNo && rulesForm.control ? false : true" @click="setNext">下一步
          </el-button>
          <el-button @click="previous">返回</el-button>
        </div>
      </el-form>

      <el-form class="loginaccount" :model="ruleForm" :rules="formRules" ref="ruleForm" v-show="!twoShow">
        <el-form-item class="login-row" prop="pwd">
          <el-input type="text" v-model="ruleForm.pwd" placeholder="密码" />
        </el-form-item>
        <el-form-item class="login-row" prop="againpwd">
          <el-input :type="showPwd ? 'text' : 'password'" style="width: 68%" v-model="ruleForm.againpwd"
            placeholder="请再次确认新密码" />
        </el-form-item>
        <div class="login-btn">
          <el-button :disabled="ruleForm.pwd && ruleForm.againpwd && (ruleForm.pwd == ruleForm.againpwd) ? false : true"
            @click="register">重置密码</el-button>
          <el-button @click="loginto">返回</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import sliderVerifyCode from "@/components/slider-verify-code.vue";
export default {
  components: { sliderVerifyCode, },
  name: "retrieveLogin",
  data() {
    //const count = 60;  倒计时的时间
    const checkStatus = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请拖动滑块完成验证"));
      } else {
        if (
          this.rulesForm.receiveNo == "" || !this.rulesForm.receiveNo
        ) {
          // this.btnShow = true;

          setTimeout(() => {
            this.rulesForm.isLock = false;
            this.$refs.rulesForm.validateField("receiveNo");
            return callback(new Error("验证未通过"));
          }, 1);
        }

        callback();
      }
    };
    // 手机号码验证
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("手机号不能为空！"));
      }
      //使用正则表达式进行验证手机号码
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号不正确！"));

      }
      callback();
    };
    // 密码是否一致
    const validatePwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error("不能为空！"));
      }
      //使用正则表达式进行验证手机号码
      // console.log(validatePhone.value);

      if (value != this.ruleForm.pwd) {
        callback(new Error("两次输入密码不一致！"));
        console.log(validatePhone.value);
        this.ruleForm.againpwd = ''
      }
      callback();
    };

    // 密码格式是否正确
    const validatePsdReg = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入密码"));
      }
      if (!/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){6,20}$/.test(value)
      ) {
        callback(
          new Error(
            "请输入6-20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种"
          )
        );
      } else {
        callback();
      }
    };

    return {
      showPwd: false,
      form: {},

      rules: {
        control: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        receiveNo: [{ required: true, validator: validatePhone, trigger: "blur" }],
        isLock: [{ validator: checkStatus, trigger: "blur" }],
      },

      formRules: {
        pwd: [
          { required: true, validator: validatePsdReg, trigger: "blur" }, { min: '6', max: '16', trigger: "blur" }],
        againpwd: [{ required: true, validator: validatePwd, trigger: "blur" }],
                             pwd: "",
        againpwd: "",
      },
      rulesForm: {
        receiveNo: "",
        control: "",
      },
      listswitch: true,
      count_show: true,
      listphoto: false,
      twoShow: true,
      loginShow: false,
      slideShow: false,
      btnShow: false,
      userInfo: {},
      count: 1,
      checked: true,
      telphone: '',
      code: '',
    };
  },
  // created(){
  // },
  methods: {
    // 验证用户是否注册
    testItem() {
      console.log('okkkkk')
      this.telphone = this.rulesForm.receiveNo
      if (!/^1[3456789]\d{9}$/.test(this.telphone)) {
        return false;
      }
      this.$axios
        .get(`/weiXin/existenceTel?telphone=${this.telphone}`)
        .then((res) => {
          console.log(res);
          console.log(res.code);
          if (res.success) {
            this.$message.error('用户不存在');
          } else {
            // this.$message({
            //     message: res.msg,
            //     type: "success",

            // });
            console.log(res.msg);

            this.slideShow = true
          }
        })
        .catch((err) => {
          alert(err)
          console.log(err);
        });

    },
    handlerLock(data) {
      if (data) {
        this.$refs.rulesForm.validateField("isLock");

      }
      this.btnShow = true;

    },
    //短信验证吗
    getCode() {
      this.count = 60; //倒计时时间
      this.count_show = false; //控制倒计时显示隐藏
      var reg_tel = /^(13[0-9]|14[01456789]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-3509])\d{8}$/;
      if (this.rulesForm.receiveNo == '') {
        alert('请填写手机号!');
        return false;
      } else if (!reg_tel.test(this.rulesForm.receiveNo)) {
        alert('请填写正确的手机号!');
        return false;
      }
      console.log(this.rulesForm.receiveNo);
      let params = {
        telphone: this.rulesForm.receiveNo
      };
      this.$axios.get('/weiXin/getCode', { params }).then(res => {
        this.btnShow = false
        console.log(res);
      })

      this.timer = setInterval(() => {
        if (this.count > 0) {
          this.count--;
        } else {
          clearInterval(this.timer);
          this.count_show = true;
          this.btnShow = true;
        }
      }, 1000);
    },
    // 下一步
    setNext() {
      this.telphone = this.rulesForm.receiveNo
      this.code = this.rulesForm.control
      this.$axios
        .post(`/weiXin/checkCode?telphone=${this.telphone}&code=${this.code}`)
        .then((res) => {
          console.log(res);
          console.log(res.code);
          if (res.code == '50000') {
            this.$message.error('格式不正确');
          } else if (res.code == '5000') {
            this.$message.error(res.data);
          } else {
            this.$message({
              message: '成功',
              type: "success",

            });
            this.twoShow = false;
            // let data = res.data
            // this.userInfo = data
            // localStorage.setItem('userInfo', JSON.stringify(data))
            // localStorage.setItem('token', data.token)
            // window.location.reload()
            // let redircetUrl = localStorage.getItem('redircetUrl')
            // if (redircetUrl) {
            //     window.location.href = redircetUrl
            //     localStorage.setItem('redircetUrl', '')
            // } else {
            //     window.location.href = '/'
            // }
          }
        })
        .catch((err) => {
          alert(err)
          console.log(err);
        });


    },
    // z重置密码
    register() {
      console.log("againpwd", this.telphone)
      console.log("pwd", this.code)
      this.$axios
        .post(`/weiXin/retrievePassword?telphone=${this.telphone}&code=${this.code}&password=${this.ruleForm.pwd}`)
        .then((res) => {
          console.log(res);
          console.log(res.code);
          if (res.code == '50000') {
            this.$message.error(res.data);
          } else {
            this.$message({
              message: '成功',
              type: "success",

            });
            window.location.href = '/login'

          }
        })
        .catch((err) => {
          alert(err)
          console.log(err);
        });

    },
    // 返回
    previous() {
      // this.$router.go(-1)
      this.twoShow = false;
      this.$emit("previous", this.twoShow);
    },
    // 返回登录页面
    loginto() {
      let that = this;
      that.twoShow = true;
      // that.loginShow = true;
    },
    transfer(abb) {
      console.log(abb)
      this.twoShow = abb;
      this.listswitch = true;
      this.listphoto = false;
    }
  },
};
</script>
<style lang="scss" scoped>
.logintwo {
  position: relative;
  padding: 0px;
  height: 720px;
  font-size: 18px;
  width: 400px;
}

.loginaccount {
  padding: 0px 50px 50px 50px;
}

.logina {
  padding: 0 50px;
}

.login-titles {
  padding: 0 50px 0px;
  color: #b2b2b2;
  margin-top: 20px;
}

.loginaccount {
  padding: 50px;
}

.login-title {
  padding: 0 50px 50px;
  color: #b2b2b2;
  margin-top: 20px;
}

.codeShow:visited {
  text-decoration: none;
}

.login-row {
  /* margin-top: 78px; */
  width: 100%;
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 10px;
  margin-top: 30px;
}

.login-row>>>.el-input__inner {
  font-size: 18px;
  outline: none;
  border: none;
  flex: 1;
  height: 22px;
  width: 100%;
}

.btn-info {
  float: right;
}

// .inputDeep>>>.el-input__inner {
//     border: 0;
//   }
.login-row .eye-icon {
  width: 24px;
  height: 20px;
  object-fit: contain;
  cursor: pointer;
}

.forget {
  font-size: 14px;
  float: right;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #999999;
}

.login-btn {
  margin-top: 40px;
  display: block;
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #ffffff;
  cursor: pointer;
}

.login-btn>>>.el-button {
  width: 100%;
  color: #ffffff;
  height: 56px;
  background-color: #f08a92;
}

.el-button+.el-button {
  margin-top: 30px;
  margin-left: 0px;
}

.login-btn.disabled {
  background-color: #f08a92;
  cursor: not-allowed;
}

// .login-logon {
//     font-size: 14px;
//     margin: 10px 130px;
// }
</style>



// WEBPACK FOOTER //
// src/components/retrieveLogin.vue